export const MM = {
    el: null,
    trigger: null,
    menu: null,
    open: false,

    options: {
        animationClasses: { classin: 'dl-animate-in-2', classout: 'dl-animate-out-2' },
        onLevelClick: (el, name) => false,
        onLinkClick: (el, ev) => false,
        openButton: undefined,
        backButtonTitle: 'Retour'
    },

    animEndEventName: null,
    transEndEventName: null,
    supportAnimations: false,
    supportTransitions: false,
    selectedElements: [],
    _history: [],

    init: function () {
        MM.el = document.querySelector('.js-mobile-header');
        if (!MM.el) return;

        MM.trigger = MM.el.querySelector('.js-mobile-trigger');
        MM.menu = MM.el.querySelector('ul.dl-menu');
        if (!MM.trigger || !MM.menu) return;

        if (window.globalOptions?.menu_mobile?.backButtonTitle) {
            MM.options.backButtonTitle = window.globalOptions.menu_mobile.backButtonTitle;
        }

        MM.options.openButton = MM.trigger;

        MM._detectEvents();
        MM._config();
        MM._initEvents();
    },

    _detectEvents: function () {
        const probe = document.createElement('div');
        const animEvents = { animation: 'animationend', WebkitAnimation: 'webkitAnimationEnd' };
        const transEvents = { transition: 'transitionend', WebkitTransition: 'webkitTransitionEnd' };

        const animKey = Object.keys(animEvents).find(k => probe.style[k] !== undefined);
        const transKey = Object.keys(transEvents).find(k => probe.style[k] !== undefined);

        MM.animEndEventName = animKey ? animEvents[animKey] : null;
        MM.transEndEventName = transKey ? transEvents[transKey] : null;
        MM.supportAnimations = !!MM.animEndEventName;
        MM.supportTransitions = !!MM.transEndEventName;
    },

    _config: function () {
        MM.open = false;
        MM._history = [];

        const subs = MM.el.querySelectorAll('ul.dl-submenu');
        subs.forEach((sub) => {
            if (sub.querySelector(':scope > li.dl-back')) return;
            const titleA = sub.parentElement ? sub.parentElement.querySelector('a') : null;
            const title = titleA ? titleA.innerHTML : '';
            const li = document.createElement('li');
            li.className = 'dl-back';
            li.innerHTML = `<a href="#" class="dl-back-link">${MM.options.backButtonTitle}<span>${title}</span></a>`;
            sub.prepend(li);
        });

        MM.menu.querySelectorAll('ul.dl-submenu').forEach(s => {
            s.style.display = 'none';
            s.setAttribute('aria-hidden', 'true');
        });

        MM._autoOpenToSelected();
    },

    _autoOpenToSelected: function () {
        const selectedLeaf = MM.el.querySelector('li.selected');
        if (!selectedLeaf) return;

        const parentUL = selectedLeaf.closest('ul.dl-submenu');
        if (!parentUL) return;

        const mainCategoryLi = parentUL.parentElement;
        
        this._performDrill(mainCategoryLi, parentUL);

        const siblings = Array.from(parentUL.children);
        const leafIndex = siblings.indexOf(selectedLeaf);
        
        let level3Header = null;
        for (let i = leafIndex; i >= 0; i--) {
            if (siblings[i].classList.contains('level-3')) {
                level3Header = siblings[i];
                break;
            }
        }

        if (level3Header) {
            const titleToFind = level3Header.textContent.trim();
            const groupedItems = Array.from(MM.menu.children);
            
            const groupedParent = groupedItems.find(li => {
                const a = li.querySelector('a.level-3-toggle');
                return a && a.textContent.trim() === titleToFind;
            });

            if (groupedParent) {
                const groupedSubmenu = groupedParent.querySelector('ul.dl-submenu');
                if (groupedSubmenu) {
                    this._performDrill(groupedParent, groupedSubmenu);
                }
            }
        }
    },

    _performDrill: function(item, submenu) {
        const link = item.querySelector('a');
        const title = link ? link.textContent.trim() : '';

        MM._history.push({
            html: MM.menu.innerHTML,
            title: title
        });

        let clones = [];
        const hasLevel3 = !!submenu.querySelector('li.level-3');
        
        if (hasLevel3) {
            clones = MM._buildGroupedNodesFromFlat(submenu);
        } else {
            Array.from(submenu.children).forEach(ch => {
                if (ch.nodeType !== 1 || ch.classList.contains('dl-back')) return;
                clones.push(ch.cloneNode(true));
            });
        }

        const backLi = document.createElement('li');
        backLi.className = 'dl-back';
        backLi.innerHTML = `<a href="#" class="dl-back-link">${MM.options.backButtonTitle}<span>${title}</span></a>`;
        clones.unshift(backLi);

        MM.menu.innerHTML = '';
        clones.forEach(c => MM.menu.appendChild(c));
        
        MM.menu.classList.add('dl-subview');
        MM.menu.setAttribute('data-dl-depth', MM._history.length.toString());
    },

    _initEvents: function () {
        MM.trigger.addEventListener('click', (e) => {
            e.preventDefault();
            MM.open ? MM._closeMenu() : MM._openMenu();
        });

        document.addEventListener('click', MM._onOutsideClick);

        MM.menu.addEventListener('click', (ev) => {
            const li = ev.target.closest('li');
            if (!li || !MM.menu.contains(li)) return;

            if (li.classList.contains('dl-back')) {
                ev.preventDefault();
                ev.stopPropagation();
                MM._goBack(li);
                return;
            }

            const submenu = li.querySelector('ul.dl-submenu');
            if (submenu && submenu.children.length > 0) {
                ev.preventDefault();
                ev.stopPropagation();
                MM._openSubmenu(li, submenu);
                return;
            }

            MM.options.onLinkClick(li, ev);
        });

        document.addEventListener('keydown', (ev) => {
            if (ev.key === 'Escape' && MM.open) MM._closeMenu();
        });
    },

    _onOutsideClick: function (e) {
        if (MM.open && !MM.el.contains(e.target)) MM.closeMenu();
    },

    closeMenu: function () { if (MM.open) MM._closeMenu(); },
    openMenu: function () { if (!MM.open) MM._openMenu(); },

    _openMenu: function () {
        MM.el.classList.add('dl-show');
        MM.menu.classList.add('dl-menuopen', 'dl-menu-toggle');
        const removeToggle = () => MM.menu.classList.remove('dl-menu-toggle');

        if (MM.supportTransitions) {
            const onEnd = () => {
                MM.menu.removeEventListener(MM.transEndEventName, onEnd);
                removeToggle();
            };
            MM.menu.addEventListener(MM.transEndEventName, onEnd);
            setTimeout(onEnd, 400);
        } else {
            removeToggle();
        }

        MM.trigger.classList.add('dl-active');
        MM.open = true;
    },

    _closeMenu: function () {
        MM.menu.classList.remove('dl-menuopen');
        MM.menu.classList.add('dl-menu-toggle');
        MM.trigger.classList.remove('dl-active');
        
        const onEnd = () => {
            if (MM.supportTransitions) MM.menu.removeEventListener(MM.transEndEventName, onEnd);
            MM.el.classList.remove('dl-show');
            MM.open = false;
        };

        if (MM.supportTransitions) {
            MM.menu.addEventListener(MM.transEndEventName, onEnd);
            setTimeout(onEnd, 500);
        } else {
            onEnd();
        }
    },

    _buildGroupedNodesFromFlat: function (submenu) {
        const nodes = [];
        const children = Array.from(submenu.children || []);
        let i = 0;
        while (i < children.length) {
            const ch = children[i];
            if (ch.nodeType !== 1 || ch.classList.contains('dl-back')) { i++; continue; }

            if (ch.classList.contains('level-3')) {
                const titleText = ch.textContent ? ch.textContent.trim() : '';
                const parentLi = document.createElement('li');
                parentLi.className = 'nav-item dropdown position-relative';
                
                const headerA = document.createElement('a');
                headerA.className = 'nav-link dropdown-toggle px-2 px-lg-4 level-3-toggle';
                headerA.setAttribute('href', '#');
                headerA.textContent = titleText;
                parentLi.appendChild(headerA);

                const nestedUL = document.createElement('ul');
                nestedUL.className = 'dl-submenu';

                const backLi = document.createElement('li');
                backLi.className = 'dl-back';
                backLi.innerHTML = `<a href="#" class="dl-back-link">${MM.options.backButtonTitle}<span>${titleText}</span></a>`;
                nestedUL.appendChild(backLi);

                let j = i + 1;
                for (; j < children.length; j++) {
                    const nxt = children[j];
                    if (nxt.nodeType !== 1) continue;
                    if (nxt.classList.contains('selected')) parentLi.classList.add('active');
                    if (nxt.classList.contains('level-3')) break;
                    nestedUL.appendChild(nxt.cloneNode(true));
                }

                parentLi.appendChild(nestedUL);
                nodes.push(parentLi);
                i = j;
                continue;
            }

            nodes.push(ch.cloneNode(true));
            i++;
        }
        return nodes;
    },

    _openSubmenu: function (item, submenu) {
        MM._history.push({
            html: MM.menu.innerHTML,
            title: item.querySelector('a') ? item.querySelector('a').textContent.trim() : ''
        });

        let clones = [];
        const hasLevel3 = !!submenu.querySelector('li.level-3');
        if (hasLevel3) {
            clones = MM._buildGroupedNodesFromFlat(submenu);
        } else {
            Array.from(submenu.children).forEach(ch => {
                if (ch.nodeType !== 1 || ch.classList.contains('dl-back')) return;
                clones.push(ch.cloneNode(true));
            });
        }

        const backLi = document.createElement('li');
        backLi.className = 'dl-back';
        const title = item.querySelector('a') ? item.querySelector('a').textContent.trim() : '';
        backLi.innerHTML = `<a href="#" class="dl-back-link">${MM.options.backButtonTitle}<span>${title}</span></a>`;
        clones.unshift(backLi);

        const outClass = 'dl-animate-out-forward';
        const inClass = 'dl-animate-in-forward';

        const outEnd = () => {
            MM.menu.removeEventListener(MM.animEndEventName, outEnd);
            MM.menu.innerHTML = '';
            clones.forEach(c => MM.menu.appendChild(c));
            MM.menu.classList.add('dl-subview');
            MM.menu.setAttribute('data-dl-depth', MM._history.length.toString());
            MM.menu.classList.remove(outClass);
            MM.menu.classList.add(inClass);
            const inEnd = () => {
                MM.menu.removeEventListener(MM.animEndEventName, inEnd);
                MM.menu.classList.remove(inClass);
            };
            MM.menu.addEventListener(MM.animEndEventName, inEnd);
        };

        MM.menu.classList.add(outClass);
        MM.menu.addEventListener(MM.animEndEventName, outEnd);
    },

    _goBack: function (backLi) {
        if (!MM._history || MM._history.length === 0) return;
        const prev = MM._history.pop();
        const outClass = 'dl-animate-out-backward';
        const inClass = 'dl-animate-in-backward';

        const outEnd = () => {
            MM.menu.removeEventListener(MM.animEndEventName, outEnd);
            MM.menu.innerHTML = prev.html || '';
            if (MM._history.length > 0) {
                MM.menu.setAttribute('data-dl-depth', MM._history.length.toString());
                MM.menu.classList.add('dl-subview');
            } else {
                MM.menu.removeAttribute('data-dl-depth');
                MM.menu.classList.remove('dl-subview');
            }
            MM.menu.classList.remove(outClass);
            MM.menu.classList.add(inClass);
            const inEnd = () => {
                MM.menu.removeEventListener(MM.animEndEventName, inEnd);
                MM.menu.classList.remove(inClass);
            };
            MM.menu.addEventListener(MM.animEndEventName, inEnd);
        };

        MM.menu.classList.add(outClass);
        MM.menu.addEventListener(MM.animEndEventName, outEnd);
    },

    _resetMenu: function () {
        MM.el.classList.remove('dl-show');
    }
};
